"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toNumberOrUndefined = toNumberOrUndefined;
/** Converts a primitive value as a number. If the value is not parsable, or ends up being NaN, then undefined
 * is returned, to allow easy use of null-coalescing operator (??). e.g toNumberOrUndefined(thing) ?? 4.5;
 *
 * This functionality deliberately does not take "any" as a parameter so that arrays are not passed to this function. If
 * you really want to pass in an "any" value, then use "as any" when providing the parameter
 */
function toNumberOrUndefined(value) {
    try {
        const parsedValue = typeof value === 'number' ? value : parseFloat(value);
        if (isNaN(parsedValue)) {
            return undefined;
        }
        return parsedValue;
    }
    catch (e) {
        return undefined;
    }
}
//# sourceMappingURL=parsing.js.map